<template>
  <div class="logo-main" @click="home_click">
    <div style="margin-right:-1vh" class="logo" :style="{ backgroundImage: `url('${logo}')` }"/>
    <div class="title"><span style="color:#F13A3A;font-size:1.2em">中创灵工</span><span style="color: rgb(204,204,204);font-size:0.9em;padding-left:10px;">综合服务平台</span></div>
  </div>
</template>

<script>
  import logo from "@/assets/images/logo.png"
  import { getCookie } from '@/utils/cookie'

  export default {
    name: "index",
    data(){
      return {
        logo
      }
    },
    methods:{
      home_click(){
        this.$router.push(getCookie('index')).catch(err => {});
      }
    }
  }
</script>

<style lang="scss" scoped>
  // style dependency
  @import "@/assets/styles/variables.scss";

  .logo-main {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 20px;
    cursor:pointer;
    > .logo {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center;
      background-color: white;
      background-size: 100%;
    }

    > .title {
      font-size: 26px;
      font-weight: 700;
      margin-left: 15px;
      color: $fontColor;
      font-family: "思源黑体 CN Bold", "思源黑体 CN Regular", "思源黑体 CN";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLayout/components/Logo/index.vue